/* Disclaimer Block JS File */
$(document).ready(function() {

});
